import { createI18n } from 'vue-i18n';
import { SystemFallbackLanguage } from '@/common/constants';
import pluralizationRules from './pluralizationRules';

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

// Create the i18n instance
const i18n = createI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || SystemFallbackLanguage, // Default locale
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || SystemFallbackLanguage, // Fallback locale
  messages: loadLocaleMessages(),
  pluralizationRules, // per-locale plural rules; see pluralizationRules.js
  globalInjection: true, // Enables `$t` globally
  silentTranslationWarn: false, // Suppress warnings for missing translations
});

const originalT = i18n.global.t;

i18n.global.t = function (key, ...args) {
  if(!key) return key;

  const translation = originalT.call(this, key, ...args);
  return translation !== key ? translation : key ?? '';
};

export default i18n;